import { toast } from 'react-toastify';
import React from 'react';
import CheckCircle from '../components/icons/CheckCircle';
import InfoOutlined from '../components/icons/InfoOutlined';
import Warning from '../components/icons/Warning';
import Close from '../components/icons/Close';
import { Box } from '@mui/material';


const defaultOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const toastStyles = {
  success: {
    className: 'toast-success-custom',
    progressClassName: 'toast-progress-success',
  },
  error: {
    className: 'toast-error-custom',
    progressClassName: 'toast-progress-error',
  },
  warning: {
    className: 'toast-warning-custom',
    progressClassName: 'toast-progress-warning',
  },
  info: {
    className: 'toast-info-custom',
    progressClassName: 'toast-progress-info',
  },
};

const CustomToastContent = ({ message, action, icon, type }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center'}}>
      {icon && (
        <div className="custom-toast-icon" style={{ marginRight: '12px', flexShrink: 0 }}>
          {icon}
        </div>
      )}
      <Box sx={{ flex: 1, fontSize: '16px', lineHeight: '1.4' }}>
        {message}
      </Box>
    </Box>
    {action && (
      <Box>
        {action}
      </Box>
    )}
  </Box>
);

export const customToast = {
  success: (message, options = {}) => {
    return toast.success(
      <CustomToastContent 
        message={message} 
        icon={options.icon || <CheckCircle style={{ color: '#fff', width: '24px', height: '24px' }} />}
        action={options.action}
        type="success"
      />, 
      {
        ...defaultOptions,
        ...options,
        ...toastStyles.success,
        icon: false,
        closeButton: ({ closeToast }) => (
          <Close 
            onClick={closeToast} 
            style={{ color: '#fff', width: '24px', height: '24px', cursor: 'pointer' }}
          />
        ),
      }
    );
  },
  error: (message, options = {}) => {
    return toast.error(
      <CustomToastContent 
        message={message} 
        icon={options.icon || <InfoOutlined style={{ color: '#FFF', width: '20px', height: '20px' }} />}
        action={options.action}
        type="error"
      />, 
      {
        ...defaultOptions,
        ...options,
        ...toastStyles.error,
        icon: false,
        closeButton: ({ closeToast }) => (
          <Close 
            onClick={closeToast} 
            style={{ color: '#fff', width: '24px', height: '24px', cursor: 'pointer' }}
          />
        ),
      }
    );
  },
  warning: (message, options = {}) => {
    return toast.warning(
      <CustomToastContent 
        message={message} 
        icon={options.icon || <Warning style={{ color: '#FFF', width: '20px', height: '20px' }} />}
        action={options.action}
        type="warning"
      />, 
      {
        ...defaultOptions,
        ...options,
        ...toastStyles.warning,
        icon: false,
        closeButton: ({ closeToast }) => (
          <Close 
            onClick={closeToast} 
            style={{ color: '#fff', width: '24px', height: '24px', cursor: 'pointer' }}
          />
        ),
      }
    );
  },
  info: (message, options = {}) => {
    return toast.info(
      <CustomToastContent 
        message={message} 
        icon={options.icon || <InfoOutlined style={{ color: '#FFF', width: '20px', height: '20px' }} />}
        action={options.action}
        type="info"
      />, 
      {
        ...defaultOptions,
        ...options,
        ...toastStyles.info,
        icon: false,
        closeButton: ({ closeToast }) => (
          <Close 
            onClick={closeToast} 
            style={{ color: '#fff', width: '24px', height: '24px', cursor: 'pointer' }}
          />
        ),
      }
    );
  },

  dismiss: (toastId) => toast.dismiss(toastId),

  dismissAll: () => toast.dismiss(),

  isActive: (toastId) => toast.isActive(toastId),
};

export const showApiResponseToast = (response_meta, message, actionConfig = null) => {
  const { type, cta } = response_meta;
  
  const toastOptions = {
    autoClose: true,
  };
  
  if (cta && actionConfig) {
    const { CustomButton, toast, navigate, path, label = "View" } = actionConfig;
    
    toastOptions.action = (
      <CustomButton 
        label={label}
        color="secondary"
        variant="text"
        size='small'
        onClick={() => {
          toast.dismiss();
          if (navigate && path) {
            navigate(path);
          }
          if (actionConfig.onClick) {
            actionConfig.onClick();
          }
        }}
      >
        {label}
      </CustomButton>
    );
  }
  
  if (customToast[type]) {
    return customToast[type](message, toastOptions);
  } else {
    return customToast.info(message, toastOptions);
  }
};

export default customToast;
